<template>
    <div class="paginated-rows" ref="paginator">
        <div class="paginator-wrapper top"
            v-if="isPaginated">
            <div class="paginator">
                <button class="page-link"
                    :disabled="disablePrev"
                    @click="prev">
                    <PrevIcon></PrevIcon>
                    <u>Prev</u>
                </button>
                <button class="page-link"
                    :disabled="disableNext"
                    @click="next">
                    <u>Next</u>
                    <NextIcon></NextIcon>
                </button>
            </div>
        </div>
        <slot></slot>
        <div class="paginator-wrapper bottom"
            v-if="isPaginated">
            <div class="paginator">
                <button class="page-link"
                    :disabled="disablePrev"
                    @click="prev">
                    <PrevIcon></PrevIcon>
                    <u>Prev</u>
                </button>
                <button class="page-link"
                    :disabled="disableNext"
                    @click="next">
                    <u>Next</u>
                    <NextIcon></NextIcon>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import  PrevIcon from '@/module/add/icons/Prev'
import  NextIcon from '@/module/add/icons/Next'

/**
 * A pagination component for patient rows in Import
 * 
 * @component
 * @example
 * <Paginator @prev="pageCount--" @next="pageCount++"
 *      :disable-prev="pageCount === 0" :disable-next="pageCount === patients.length"></Paginator>
 */
export default {
    name: 'import-paginator',

    props: {
        /**
         * Disable the previous page button
         */
        disablePrev: {
            type: Boolean,
            default: false
        },
        /**
         * Disable the next page button
         */
        disableNext: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        /**
         * Go to previous page
         */
        prev() {
            /**
             * Triggers going to previous page
             */
            this.$emit('prev')
            // Scroll to top of this component
            this.$refs.paginator.scrollTop = 0
        },
        /**
         * Go to next page
         */
        next() {
            /**
             * Triggers going to next page
             */
            this.$emit('next')
            // Scroll to top of this component
            this.$refs.paginator.scrollTop = 0
        }
    },

    computed: {
        /**
         * Calculates whether pagination is needed 
         *
         * @returns
         */
        isPaginated() {
            return !this.disablePrev || !this.disableNext
        }
    },

    components: {
        PrevIcon,
        NextIcon
    }
}
</script>

<style lang="scss" scoped>
@import "@/module/app/theme/color.scss";

// Color of the paginator component
$paginator-color: #4a9bf9;

.paginated-rows {
    max-height: 800px;
    overflow-y: scroll;
}

.paginator-wrapper {
    background-color: $white-color;

    &.top {
        padding-top: 10px;
    }

    &.bottom {
        padding-bottom: 20px;
    }

    .paginator {
        background-color: $grey-000;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;

        .page-link {
            border: none;
            background-color: inherit;
            color: $paginator-color;
            font-size: 16px;
            line-height: 16px;
            font-weight: 400;
            padding: 0 5px;
            cursor: pointer;

            &[disabled] {
                opacity: 0.4;
                cursor: not-allowed;
            }
            u {
                padding: 0 10px;
            }
        }

        .page-link:first-child {
            border-right: 1px solid $paginator-color;
        }

        .page-link:hover {
            text-shadow: 0 0 0 $paginator-color;
        }
    }
}
</style>